import BaseApiAction from '@Actions/base-api-action';

export type GetUserReportPayload = {
  user_ids: string[],
  from_date?: string,
  to_date?: string,
}

export default class GetUserReport extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'reports-getUserReport',
      payload: { ...this._payload  },
    });
  }

  onError(response: any): void {
    super.onError(response);
    console.log('GetUserReport error', response);
  }
}